document.addEventListener('DOMContentLoaded', function () {
  var desktopNav = document.querySelector('.menu-holder');
  var desktopMenuItems = desktopNav.querySelectorAll('[data-menu]');
  var desktopTopLevelMenuItems = desktopNav.querySelectorAll('.menu-item-has-children > a');
  var mobileNav = document.querySelector('#mobile-menu');
  var mobileMenuItems = mobileNav.querySelectorAll('[data-menu]');

  var toggleProductsMenuForDesktop = function (event) {
    var menuId = event.target.dataset.menu;
    var desktopProducts = desktopNav.querySelectorAll('[data-parent-menu]');
    var desktopAssociatedProducts = desktopNav.querySelectorAll('[data-parent-menu="' + menuId + '"]');

    desktopMenuItems.forEach(function (menuItem) {
      menuItem.classList.remove('active');
    });
    event.target.classList.add('active');

    if (desktopProducts === null) {
      return;
    }
    desktopProducts.forEach(function (desktopProduct) {
      desktopProduct.classList.remove('products-menu__item--shown');
    });

    if (desktopAssociatedProducts === null) {
      return;
    }
    desktopAssociatedProducts.forEach(function (desktopAssociatedProduct) {
      desktopAssociatedProduct.classList.add('products-menu__item--shown');
    });
  };

  var toggleProductsMenuForMobile = function (event) {
    event.preventDefault();

    var button = event.target;
    var mobileAssociatedProductMenu = button.nextElementSibling;

    if (mobileAssociatedProductMenu === null) {
      return;
    }

    // Toggle active state
    var isActive = button.classList.contains('active');

    if (isActive) {
      // Remove active classes and set aria-expanded to false
      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      mobileAssociatedProductMenu.classList.remove('products-menu--shown');
    } else {
      // Add active classes and set aria-expanded to true
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      mobileAssociatedProductMenu.classList.add('products-menu--shown');
    }
  };





  // Set event listeners for desktop navigation on load.
  desktopMenuItems.forEach(function (desktopMenuItem) {
    desktopMenuItem.addEventListener('click', toggleProductsMenuForDesktop);
    desktopMenuItem.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleProductsMenuForDesktop(event);
      }
    });
  });

  // Clone items from desktop navigation to mobile navigation on load. Only
  // applies to the first menu, which is for products.
  mobileMenuItems.forEach(function (mobileMenuItem) {
    var menuId = mobileMenuItem.dataset.menu;
    var firstMenuItem = desktopNav.querySelector('.menu-item-has-children');

    if (firstMenuItem) {
        var desktopAssociatedProducts = firstMenuItem.querySelectorAll('[data-parent-menu="' + menuId + '"]');

        desktopAssociatedProducts.forEach(function (desktopAssociatedProduct) {
          var mobileAssociatedProduct = desktopAssociatedProduct.cloneNode(true);

          mobileMenuItem.nextElementSibling.append(mobileAssociatedProduct);
        });
    }
  });

  // Then, set event listeners for mobile navigation.
  mobileMenuItems.forEach(function (mobileMenuItem) {
    mobileMenuItem.addEventListener('click', toggleProductsMenuForMobile);
  });

  // Prevent clicks for top-level menu items that have children.
  desktopTopLevelMenuItems.forEach(function (menuItem) {
    menuItem.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });
});
